import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getQuestionsAndAnswers,
  getQuestionsByCategory
} from "../../store/selectors";
import { appraisalSlice } from "../../store/slices/Appraisal";
import { useSourceSystem } from "../../hooks/useSourceSystem";

export const useAnswersReview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const factualQuestions = useSelector(getQuestionsByCategory("Factual"));
  const conditionQuestions = useSelector(getQuestionsByCategory("Condition"));
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const questions = [...factualQuestions, ...conditionQuestions];
  const [updatedQuestionsAndAnswers, setUpdatedQuestionsAndAnswers] =
    useState(questionsAndAnswers);
  const [hasChanged, setHasChanged] = useState(false);
  const handleChange = ({
    questionId,
    answerId
  }: {
    questionId: number;
    answerId: number;
  }) => {
    setHasChanged(true);
    dispatch(appraisalSlice.actions.setAnswersChanged(true));
    dispatch(
      appraisalSlice.actions.setQuestionsAndAnswers({ [questionId]: [answerId] })
    );
    setUpdatedQuestionsAndAnswers({
      ...updatedQuestionsAndAnswers,
      [questionId]: [answerId]
    });
  };
  const { sourceSystem: { analyticSearchParam } } = useSourceSystem()

  return {
    questions,
    questionsAndAnswers,
    handleChange,
    navigate,
    hasChanged,
    analyticSearchParam
  };
};
